import DomUtils from './DomUtils';
import { keyCodes } from '../../common/constants';

function moveToItem(fn, list, currentElement) {
    let focusedElement = fn(list, currentElement);

    while (focusedElement) {
        const tabIndex = focusedElement.getAttribute('tabindex');

        if (tabIndex == -1 || focusedElement.disabled) {
            focusedElement = fn(list, focusedElement);
        } else {
            focusedElement.focus();
            break;
        }
    }
}

function nextItem(list, item) {
    if (list === item) {
        return list.firstChild;
    }
    if (item && item.nextElementSibling) {
        return item.nextElementSibling;
    }
    return list.firstChild;
}

function previousItem(list, item) {
    if (list === item) {
        return list.lastChild;
    }
    if (item && item.previousElementSibling) {
        return item.previousElementSibling;
    }
    return list.lastChild;
}

function navigateToItem(e) {
    return function(listElement, currentElement) {
        const { END, HOME, UP, DOWN } = keyCodes;
        const charCode = DomUtils.getCharCode(e);

        if (charCode === END) {
            e.preventDefault();
            moveToItem(previousItem, listElement);
        } else if (charCode === HOME) {
            e.preventDefault();
            moveToItem(nextItem, listElement);
        } else if (charCode === UP) {
            e.preventDefault();
            moveToItem(previousItem, listElement, currentElement);
        } else if (charCode === DOWN) {
            e.preventDefault();
            moveToItem(nextItem, listElement, currentElement);
        }
    };
}

export default {
    moveToItem,
    nextItem,
    previousItem,
    navigateToItem
};
